var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkstations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(-1859 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    transform: "translate(1859 170)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 37,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 36,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    transform: "translate(1873 173)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    transform: "translate(1862 173)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    transform: "translate(1873 184)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    transform: "translate(1862 184)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    transform: "translate(1873 195)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    transform: "translate(1862 195)",
    fill: "none",
    stroke: "#37b3a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 8,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkstations);
export default __webpack_public_path__ + "static/media/workstations.a4adc052.svg";
export { ForwardRef as ReactComponent };